import Messanger from './pages/Messanger';


function App() {

  return (
    <>
    <Messanger/>
    </>
  );
}

export default App;
